// Parsina campaign landing — a single conversion-focused page.
// Structure follows the campaign-landing shape (hero → value → features →
// steps → form → FAQ → final CTA), with Parsina's own identity throughout.

import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';

import { captureUtm } from './src/lib/utm.js';
import LeadForm from './src/components/LeadForm.jsx';
import {
  Header,
  Hero,
  PainPoints,
  Features,
  HowItWorks,
  Faq,
  FinalCta,
  StickyCta,
  Footer,
} from './src/components/sections.jsx';

function App() {
  // Once the lead is in, every "ثبت درخواست" on the page is a dead end — the
  // sticky bar would scroll the visitor back to their own success card.
  const [submitted, setSubmitted] = useState(false);

  // Capture campaign attribution on first paint, before the visitor can
  // navigate the query string away.
  useEffect(() => {
    try {
      captureUtm(window.location.search, window.sessionStorage);
    } catch {
      /* private mode — submission falls back to the live query string */
    }
  }, []);

  return (
    <div dir="rtl">
      <Header />
      <main>
        <Hero />
        <PainPoints />
        <Features />
        <HowItWorks />
        <section id="lead-form" className="mx-auto max-w-2xl scroll-mt-20 px-4 py-12 sm:py-20">
          <h2 className="text-center text-xl font-black text-ink sm:text-3xl">
            درخواست مشاوره و نمایش پنل پزشک
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-center text-[12.5px] leading-[1.9] text-ink-soft sm:text-sm sm:leading-7">
            فرم زیر را پر کنید؛ کارشناسان پارسینا در اولین فرصت با شما تماس می‌گیرند.
          </p>
          <div className="mt-6 sm:mt-8">
            <LeadForm onSubmitted={() => setSubmitted(true)} />
          </div>
        </section>
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      {!submitted && <StickyCta />}
    </div>
  );
}

createRoot(document.getElementById('root')).render(<App />);
